import { createReducer, on } from "@ngrx/store";


export interface HomeState {
    timelineGroupsData: any[],
    start: Date | undefined,
    end: Date | undefined,
    minTime : Date | undefined,
    maxTime : Date | undefined,
    error: any
}

export const initialeState: HomeState = {
    timelineGroupsData: [],
    start: undefined,
    end: undefined,
    minTime : undefined,
    maxTime : undefined,
    error: []
}


export const homeReducer = createReducer(
    initialeState,



)

